import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-danvi-slider-mobile",
  templateUrl: "./danvi-slider-mobile.component.html",
  styleUrls: ["./danvi-slider-mobile.component.scss"],
})
export class DanviSliderMobileComponent implements OnInit {
  slides = [
    { img: "assets/img/danvi/danvi_mob_01.webp" },
    { img: "assets/img/danvi/danvi_mob_04.webp" },
    { img: "assets/img/danvi/danvi_mob_02.webp" },
    { img: "assets/img/danvi/danvi_mob_05.webp" },
    { img: "assets/img/danvi/danvi_mob_03.webp" },
  ];

  breakpoints = [
    {
      breakpoint: 9999,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ];

  slideConfig = {
    dots: true,
    responsive: this.breakpoints,
  };

  slickInit(e) {
    console.log("slick initialized");
  }

  breakpoint(e) {
    console.log("breakpoint");
  }

  afterChange(e) {
    console.log("afterChange");
  }

  beforeChange(e) {
    console.log("beforeChange");
  }

  constructor() {}

  ngOnInit() {}
}
